export default __webpack_public_path__ + "static/media/325D.c3029f88.jpg";